// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout styles */

.page {
  display: flex;
  min-height: 100vh;
}

.notification-popover {
  position: fixed !important;
  top: 72px;
  right: clamp(12px, 2vw, 32px);
  left: auto !important;
  width: min(420px, calc(100vw - 24px));
  max-height: min(72vh, 560px);
  overflow-y: auto;
  border: 1px solid rgba(13, 89, 98, 0.14);
  border-radius: 14px;
  box-shadow: 0 18px 42px rgba(7, 35, 43, 0.22);
}

.user-account-menu {
  position: fixed !important;
  top: 58px !important;
  right: clamp(14px, 2vw, 32px) !important;
  left: auto !important;
  margin-top: 0 !important;
  /* Below the modal layer (Bootstrap .modal is 1055, .modal-backdrop 1040).
     At 1085 this dropdown rendered over an open modal. 1035 still clears the
     navbars (1030/1029) and the sticky page header (1020). */
  z-index: 1035 !important;
  max-height: calc(100vh - 76px);
  overflow-y: auto;
}

.user-account-menu.dropdown-menu-arrow::before,
.user-account-menu.dropdown-menu-arrow::after {
  right: 18px;
  left: auto;
}


/* Sidebar styles */
.navbar-vertical {
  width: 15rem;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  will-change: width;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.navbar-vertical::-webkit-scrollbar {
  display: none;
}

/* Mobile styles */
@media (max-width: 992px) {
  .navbar-vertical {
    display: none;
  }

  /* When menu is open, prevent page scroll */
  body.menu-open {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
  }

  .page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative;
  }

  .page-wrapper {
    margin-left: 0 !important;
    flex: 1 1;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  /* Mobile navbar styles */
  .mobile-navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 64px;
    background-color: #1f656c;
    z-index: 1030;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .mobile-navbar-brand {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-navbar-brand img {
    height: 40px;
    width: auto;
    filter: brightness(0) invert(1);
  }

  .mobile-menu-button,
  .mobile-user-profile,
  .mobile-navbar-actions .nav-link {
    background: none;
    border: none;
    color: white;
    padding: 0.5rem;
    cursor: pointer;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    transition: background-color 0.2s ease;
  }

  .mobile-menu-button:hover,
  .mobile-user-profile:hover,
  .mobile-navbar-actions .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .mobile-navbar-actions {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    z-index: 2;
  }

  .mobile-navbar-actions .nav-item {
    display: flex;
    align-items: center;
  }

  .mobile-navbar-actions .nav-link {
    color: #fff !important;
    min-width: 44px;
    min-height: 44px;
    padding: 0.5rem !important;
    border-radius: 0.75rem;
  }

  /* !important on every positioning property here, not just width: this
     element also carries the global .notification-popover class (see top of
     file), whose left: auto !important otherwise wins the cascade over this
     rule's left: 0.75rem (not !important beats !important, regardless of
     this selector's higher specificity). The previous partial-!important
     split resolved to left:auto + width:auto + right:0.75rem on mobile --
     with no left edge pinned, the box shrink-to-fits to its content width,
     which routinely exceeds a narrow phone's viewport and overflows off the
     left edge. Every property that must win on mobile is !important now, so
     there is no property-by-property tug of war with the global rule. */
  .mobile-navbar-actions .dropdown-menu {
    position: fixed !important;
    top: 72px !important;
    right: 0.75rem !important;
    left: 0.75rem !important;
    width: auto !important;
    max-height: min(70vh, 32rem) !important;
    overflow-y: auto;
    border: 1px solid rgba(13, 89, 98, 0.14);
    border-radius: 1rem;
    box-shadow: 0 18px 42px rgba(7, 35, 43, 0.24);
  }

  /* Mobile menu styles */
  .mobile-menu {
    position: fixed;
    top: 64px; /* Height of navbar */
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #1f656c;
    z-index: 1029;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.3s, opacity 0.3s ease;
    display: flex;
    flex-direction: column;
  }

  .mobile-menu.show {
    visibility: visible;
    opacity: 1;
    transition-delay: 0s;
  }

  .mobile-menu-content {
    flex: 1 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 80px;
    overscroll-behavior: contain; /* Prevent scroll chaining */
  }

  /* Hide scrollbar */
  .mobile-menu-content {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .mobile-menu-content::-webkit-scrollbar {
    display: none;
  }

  /* Page content styles */
  /* No z-index here. \`position: relative\` + any numeric z-index makes
     .page-content a stacking context, which exists only below 992px. Most
     form modals render their .modal div inline in the page tree (inside
     .page-content) while portaling only \`.modal-backdrop\` to <body>. Inside
     a stacking context the modal's z-index:1055 is scoped locally, so the
     whole subtree resolves at z-index:1 against the root -- underneath the
     body-level backdrop at 1040. The modal stayed visible but the backdrop
     covered it, so every tap hit the backdrop (usually closing the modal)
     and no field or button in the form could be used on mobile.
     \`position: relative\` is kept: descendants use it as a containing block.
     It creates no stacking context on its own with z-index: auto. */
  .page-content {
    padding: 1rem;
    margin-top: 64px; /* Height of mobile navbar */
    flex: 1 1;
    position: relative;
  }

  /* Mobile menu items */
  .mobile-menu .nav-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .mobile-menu .nav-link {
    color: rgba(255, 255, 255, 0.7);
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    transition: all 0.2s ease;
  }

  .mobile-menu .nav-link-icon {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mobile-menu .nav-link-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1;
  }

  .mobile-menu .nav-link-title {
    font-size: 1rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
  }

  /* Mobile dropdown styles */
  .mobile-menu .dropdown-menu {
    position: static !important;
    background-color: rgba(0, 0, 0, 0.2);
    border: none;
    margin: 0;
    padding: 0.5rem 0;
    transform: none !important;
    transition: max-height 0.3s ease-in-out;
    max-height: 0;
    overflow: hidden;
  }

  .mobile-menu .dropdown.show .dropdown-menu {
    max-height: 500px;
  }

  .mobile-menu .dropdown-item {
    color: rgba(255, 255, 255, 0.7);
    padding: 0.75rem 3rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s ease;
  }

  .mobile-menu .dropdown-item:active,
  .mobile-menu .nav-link:active {
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
  }

  /* Active states */
  .mobile-menu .nav-link.active {
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .mobile-menu .dropdown-item.active {
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
  }
}

/* Mobile backdrop overlay */
.navbar-vertical-backdrop {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1020;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.navbar-vertical .container-fluid {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.navbar-vertical .navbar-brand {
  padding: 1rem;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 64px;
  position: sticky;
  top: 0;
  background-color: inherit;
  z-index: 1;
}

.navbar-vertical .navbar-collapse {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 1rem;
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.navbar-vertical .navbar-collapse::-webkit-scrollbar {
  display: none;
}

.navbar-vertical:hover {
  overflow: visible;
}

.navbar-vertical .logo-expanded {
  max-width: 120px;
  height: auto;
  filter: brightness(0) invert(1);
  will-change: opacity;
}

.navbar-vertical .logo-collapsed {
  filter: brightness(0) invert(1);
  width: 66px;
  height: 66px;
  will-change: opacity;
}

.navbar-vertical.bg-dark {
  background-color: #1f656c !important;
}

.navbar-vertical .nav-link {
  color: rgba(255, 255, 255, 0.7);
  padding: 0.5rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}

.navbar-vertical .nav-link:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-vertical .nav-link.active {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
}

.navbar-vertical.collapsed {
  width: 4.5rem;
}

.navbar-vertical.collapsed .navbar-brand {
  padding: 0.5rem;
}

.navbar-vertical.collapsed .nav-link-title,
.navbar-vertical.collapsed .navbar-divider {
  opacity: 0;
  display: none;
}

/* Keep small text visible but hidden when collapsed */
.navbar-vertical.collapsed .small.text-muted {
  visibility: hidden;
  opacity: 1;
}

.navbar-vertical.collapsed .nav-link {
  padding: 0.5rem;
  justify-content: center;
}

.navbar-vertical.collapsed .nav-link-icon {
  margin: 0;
}

/* Show text when hovering over collapsed sidebar */
.navbar-vertical.collapsed:hover .small.text-muted {
  visibility: visible;
}

/* Dropdown styles */
.navbar-vertical .dropdown-menu {
  margin-left: 1rem;
  background-color: rgba(31, 101, 108, 0.95);
  backdrop-filter: blur(10px);
  border: none;
  border-radius: 0.5rem;
}

.navbar-vertical.collapsed .dropdown-menu {
  margin-left: 4.5rem;
  position: absolute;
  top: 0;
  left: 0;
}

.mobile-menu.dropdown-item {
  color: rgba(255, 255, 255, 0.7);
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
}

.mobile-menu.dropdown-item:hover {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.1);
}

.dropdown-item.active {
  color: #ffffff;
  background-color: rgba(255, 255, 255, 0.15);
}

/* Ensure sidebar dropdown items render icons consistently on all screen sizes */
.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 0.35rem;
  white-space: normal;
  line-height: 1.25;
}

.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item svg {
  flex: 0 0 auto;
}

.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item .flex-grow-1,
.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item span:not(.badge) {
  min-width: 0;
  overflow-wrap: anywhere;
}

.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item .badge {
  flex: 0 0 auto;
}

/* Main content wrapper styles */
.page-wrapper {
  flex: 1 1;
  min-width: 0;
  margin-left: 15rem;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  will-change: margin-left;
}

.navbar-vertical.collapsed + .page-wrapper {
  margin-left: 4.5rem;
}

/* Header styles */
.navbar {
  padding: 0.5rem 1rem;
  background-color: #fff;
  border-bottom: 1px solid #e5e7eb;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

/* Main content styles */
.page-content {
  flex: 1 1;
  min-height: 0;
  padding: 1.5rem;
  background-color: #f8fafc;
}

/* ═══════════════════════════════════════════════════════════
 * GLOBAL MOBILE RESPONSIVE — applies to ALL pages
 * ═══════════════════════════════════════════════════════════ */

/* ── Smooth page transitions ──────────────────────────────── */
/* .modal is deliberately absent: \`transition: all\` on it overrides Bootstrap's
   own \`.modal.fade\` opacity ramp and \`.modal.fade .modal-dialog\` transform
   ramp with a single blanket curve, so open/close animates inconsistently.
   Bootstrap already ships the transitions the modal needs. */
.page-content,
.card,
.btn,
.nav-link,
.dropdown-menu,
.offcanvas {
  transition: all 0.2s ease;
}

.card {
  transition: box-shadow 0.2s ease, transform 0.15s ease;
}

.btn {
  transition: background-color 0.15s ease, border-color 0.15s ease,
              box-shadow 0.15s ease, transform 0.1s ease;
}

.btn:active {
  transform: scale(0.97);
}

/* ── Table responsive: horizontal scroll on mobile ───────── */
@media (max-width: 992px) {
  /* All tables inside cards scroll horizontally */
  .card-body > .table,
  .card-body > .table-responsive > .table,
  .card > .table {
    min-width: 540px;
  }

  /* Wrap bare tables (not already in table-responsive) */
  .card-body {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Prevent the whole page from horizontal scroll */
  .page-wrapper {
    overflow-x: hidden;
  }

  /* Setting overflow-x alone forces the browser to compute overflow-y as
     auto too (CSS overflow spec), turning .page-wrapper into a clipping
     context for any position:absolute descendant — including the desktop
     navbar's UserMenu/NotificationDropdown dropdown-menu, which then
     rendered visibly cut off instead of overlaying the page. Escape it with
     position:fixed, the same pattern already used for
     .mobile-navbar-actions .dropdown-menu below. */
  .container-fluid > header.navbar .dropdown-menu {
    position: fixed;
    top: 4.5rem;
    right: 1rem;
  }

  /* Page header: stack action buttons on small screens */
  .page-header .row {
    row-gap: 0.5rem;
  }

  .page-header .col-auto {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Card padding tighter on mobile */
  .card-body {
    padding: 0.875rem;
  }

  /* Badge / status chips don't break */
  .badge {
    white-space: nowrap;
  }

  /* Table font slightly smaller on mobile */
  .table {
    font-size: 0.85rem;
  }

  /* Table header: prevent wrapping in th */
  .table th {
    white-space: nowrap;
  }
}

@media (max-width: 576px) {
  .page-content {
    padding: 0.75rem;
  }

  .card-body {
    padding: 0.625rem;
  }

  .table {
    font-size: 0.8rem;
  }

  /* Stat / KPI cards: 2 per row on very small screens */
  .col-sm-6.col-lg-3,
  .col-6.col-lg-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  /* Buttons full-width when stacked */
  .btn-block-mobile {
    width: 100%;
  }

  /* Modals: full screen feel */
  .modal-dialog {
    margin: 0.5rem;
    max-width: calc(100vw - 1rem);
  }
}

/* ── Prevent content overflow globally ───────────────────── */
img,
video,
iframe {
  max-width: 100%;
  height: auto;
}

/* ── Offcanvas: full width on very small screens ─────────── */
@media (max-width: 480px) {
  .offcanvas {
    width: 100vw !important;
    max-width: 100vw !important;
  }
}

/* Additional touch optimizations */
@media (hover: none) {
  .navbar-vertical .nav-link:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  .cursor-pointer:hover {
    background-color: transparent;
  }

  .navbar-vertical .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
}

.nav-item-tab .nav-link{
  color: #6b7280;
}

.nav-item-tab .nav-link:hover{
  color: #000000;
}

.nav-item-tab .nav-link.active{
  color: #000000;
}

/* Table sorting styles */
.cursor-pointer {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.cursor-pointer:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.sort-icon {
  display: inline-block;
  vertical-align: middle;
  opacity: 0.3;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.sort-icon.text-primary {
  opacity: 1;
}

th[data-sort]:hover .sort-icon {
  opacity: 0.8;
}

/* Mobile menu dropdown styles - keeping these separate */
@media (max-width: 992px) {
  .mobile-menu .dropdown-menu {
    position: static !important;
    background-color: rgba(0, 0, 0, 0.2);
    border: none;
    margin: 0;
    padding: 0.5rem 0;
    transform: none !important;
    transition: max-height 0.3s ease-in-out;
    max-height: 0;
    overflow: hidden;
  }

  .mobile-menu .dropdown.show .dropdown-menu {
    max-height: 500px;
  }

  .mobile-menu .dropdown-item {
    color: rgba(255, 255, 255, 0.7);
    padding: 0.75rem 3rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s ease;
  }

  .mobile-menu .dropdown-item:active,
  .mobile-menu .nav-link:active {
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,6BAA6B;EAC7B,qBAAqB;EACrB,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,wCAAwC;EACxC,qBAAqB;EACrB,wBAAwB;EACxB;;6DAE2D;EAC3D,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,UAAU;AACZ;;;AAGA,mBAAmB;AACnB;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,wBAAwB;EACxB,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,+BAA+B;EACjC;;EAEA;;;IAGE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;;;IAGE,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;;;;;;;;wEASsE;EACtE;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;IAChB,wCAAwC;IACxC,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA,uBAAuB;EACvB;IACE,eAAe;IACf,SAAS,EAAE,qBAAqB;IAChC,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,wDAAwD;IACxD,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,iCAAiC;IACjC,oBAAoB;IACpB,4BAA4B,EAAE,4BAA4B;EAC5D;;EAEA,mBAAmB;EACnB;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA,wBAAwB;EACxB;;;;;;;;;;oEAUkE;EAClE;IACE,aAAa;IACb,gBAAgB,EAAE,4BAA4B;IAC9C,SAAO;IACP,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,iDAAiD;EACnD;;EAEA;IACE,+BAA+B;IAC/B,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA,2BAA2B;EAC3B;IACE,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,0BAA0B;IAC1B,uCAAuC;IACvC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,2CAA2C;IAC3C,YAAY;EACd;;EAEA,kBAAkB;EAClB;IACE,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,YAAY;IACZ,0CAA0C;EAC5C;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;gEAEgE;;AAEhE,gEAAgE;AAChE;;;6DAG6D;AAC7D;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;wDACsD;AACxD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,gDAAgD;EAChD;;;IAGE,gBAAgB;EAClB;;EAEA,uDAAuD;EACvD;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,kDAAkD;EAClD;IACE,kBAAkB;EACpB;;EAEA;;;;;;mDAMiD;EACjD;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA,uDAAuD;EACvD;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,mBAAmB;EACrB;;EAEA,0CAA0C;EAC1C;IACE,kBAAkB;EACpB;;EAEA,yCAAyC;EACzC;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,sDAAsD;EACtD;;IAEE,aAAa;IACb,cAAc;EAChB;;EAEA,oCAAoC;EACpC;IACE,WAAW;EACb;;EAEA,6BAA6B;EAC7B;IACE,cAAc;IACd,6BAA6B;EAC/B;AACF;;AAEA,+DAA+D;AAC/D;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA,+DAA+D;AAC/D;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,yDAAyD;AACzD;EACE;IACE,2BAA2B;IAC3B,oCAAoC;IACpC,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,0BAA0B;IAC1B,uCAAuC;IACvC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,2CAA2C;IAC3C,YAAY;EACd;AACF","sourcesContent":["/* Layout styles */\n\n.page {\n  display: flex;\n  min-height: 100vh;\n}\n\n.notification-popover {\n  position: fixed !important;\n  top: 72px;\n  right: clamp(12px, 2vw, 32px);\n  left: auto !important;\n  width: min(420px, calc(100vw - 24px));\n  max-height: min(72vh, 560px);\n  overflow-y: auto;\n  border: 1px solid rgba(13, 89, 98, 0.14);\n  border-radius: 14px;\n  box-shadow: 0 18px 42px rgba(7, 35, 43, 0.22);\n}\n\n.user-account-menu {\n  position: fixed !important;\n  top: 58px !important;\n  right: clamp(14px, 2vw, 32px) !important;\n  left: auto !important;\n  margin-top: 0 !important;\n  /* Below the modal layer (Bootstrap .modal is 1055, .modal-backdrop 1040).\n     At 1085 this dropdown rendered over an open modal. 1035 still clears the\n     navbars (1030/1029) and the sticky page header (1020). */\n  z-index: 1035 !important;\n  max-height: calc(100vh - 76px);\n  overflow-y: auto;\n}\n\n.user-account-menu.dropdown-menu-arrow::before,\n.user-account-menu.dropdown-menu-arrow::after {\n  right: 18px;\n  left: auto;\n}\n\n\n/* Sidebar styles */\n.navbar-vertical {\n  width: 15rem;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n  will-change: width;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  /* Hide scrollbar for IE, Edge and Firefox */\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.navbar-vertical::-webkit-scrollbar {\n  display: none;\n}\n\n/* Mobile styles */\n@media (max-width: 992px) {\n  .navbar-vertical {\n    display: none;\n  }\n\n  /* When menu is open, prevent page scroll */\n  body.menu-open {\n    overflow: hidden;\n    position: fixed;\n    width: 100%;\n    height: 100%;\n  }\n\n  .page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    position: relative;\n  }\n\n  .page-wrapper {\n    margin-left: 0 !important;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  /* Mobile navbar styles */\n  .mobile-navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 64px;\n    background-color: #1f656c;\n    z-index: 1030;\n    padding: 0 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  .mobile-navbar-brand {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .mobile-navbar-brand img {\n    height: 40px;\n    width: auto;\n    filter: brightness(0) invert(1);\n  }\n\n  .mobile-menu-button,\n  .mobile-user-profile,\n  .mobile-navbar-actions .nav-link {\n    background: none;\n    border: none;\n    color: white;\n    padding: 0.5rem;\n    cursor: pointer;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 8px;\n    transition: background-color 0.2s ease;\n  }\n\n  .mobile-menu-button:hover,\n  .mobile-user-profile:hover,\n  .mobile-navbar-actions .nav-link:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .mobile-navbar-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    z-index: 2;\n  }\n\n  .mobile-navbar-actions .nav-item {\n    display: flex;\n    align-items: center;\n  }\n\n  .mobile-navbar-actions .nav-link {\n    color: #fff !important;\n    min-width: 44px;\n    min-height: 44px;\n    padding: 0.5rem !important;\n    border-radius: 0.75rem;\n  }\n\n  /* !important on every positioning property here, not just width: this\n     element also carries the global .notification-popover class (see top of\n     file), whose left: auto !important otherwise wins the cascade over this\n     rule's left: 0.75rem (not !important beats !important, regardless of\n     this selector's higher specificity). The previous partial-!important\n     split resolved to left:auto + width:auto + right:0.75rem on mobile --\n     with no left edge pinned, the box shrink-to-fits to its content width,\n     which routinely exceeds a narrow phone's viewport and overflows off the\n     left edge. Every property that must win on mobile is !important now, so\n     there is no property-by-property tug of war with the global rule. */\n  .mobile-navbar-actions .dropdown-menu {\n    position: fixed !important;\n    top: 72px !important;\n    right: 0.75rem !important;\n    left: 0.75rem !important;\n    width: auto !important;\n    max-height: min(70vh, 32rem) !important;\n    overflow-y: auto;\n    border: 1px solid rgba(13, 89, 98, 0.14);\n    border-radius: 1rem;\n    box-shadow: 0 18px 42px rgba(7, 35, 43, 0.24);\n  }\n\n  /* Mobile menu styles */\n  .mobile-menu {\n    position: fixed;\n    top: 64px; /* Height of navbar */\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #1f656c;\n    z-index: 1029;\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s linear 0.3s, opacity 0.3s ease;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mobile-menu.show {\n    visibility: visible;\n    opacity: 1;\n    transition-delay: 0s;\n  }\n\n  .mobile-menu-content {\n    flex: 1;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 80px;\n    overscroll-behavior: contain; /* Prevent scroll chaining */\n  }\n\n  /* Hide scrollbar */\n  .mobile-menu-content {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .mobile-menu-content::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Page content styles */\n  /* No z-index here. `position: relative` + any numeric z-index makes\n     .page-content a stacking context, which exists only below 992px. Most\n     form modals render their .modal div inline in the page tree (inside\n     .page-content) while portaling only `.modal-backdrop` to <body>. Inside\n     a stacking context the modal's z-index:1055 is scoped locally, so the\n     whole subtree resolves at z-index:1 against the root -- underneath the\n     body-level backdrop at 1040. The modal stayed visible but the backdrop\n     covered it, so every tap hit the backdrop (usually closing the modal)\n     and no field or button in the form could be used on mobile.\n     `position: relative` is kept: descendants use it as a containing block.\n     It creates no stacking context on its own with z-index: auto. */\n  .page-content {\n    padding: 1rem;\n    margin-top: 64px; /* Height of mobile navbar */\n    flex: 1;\n    position: relative;\n  }\n\n  /* Mobile menu items */\n  .mobile-menu .nav-item {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .mobile-menu .nav-link {\n    color: rgba(255, 255, 255, 0.7);\n    padding: 1rem 1.5rem;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    transition: all 0.2s ease;\n  }\n\n  .mobile-menu .nav-link-icon {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  .mobile-menu .nav-link-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 1;\n  }\n\n  .mobile-menu .nav-link-title {\n    font-size: 1rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  /* Mobile dropdown styles */\n  .mobile-menu .dropdown-menu {\n    position: static !important;\n    background-color: rgba(0, 0, 0, 0.2);\n    border: none;\n    margin: 0;\n    padding: 0.5rem 0;\n    transform: none !important;\n    transition: max-height 0.3s ease-in-out;\n    max-height: 0;\n    overflow: hidden;\n  }\n\n  .mobile-menu .dropdown.show .dropdown-menu {\n    max-height: 500px;\n  }\n\n  .mobile-menu .dropdown-item {\n    color: rgba(255, 255, 255, 0.7);\n    padding: 0.75rem 3rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.2s ease;\n  }\n\n  .mobile-menu .dropdown-item:active,\n  .mobile-menu .nav-link:active {\n    background-color: rgba(255, 255, 255, 0.15);\n    color: white;\n  }\n\n  /* Active states */\n  .mobile-menu .nav-link.active {\n    color: white;\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .mobile-menu .dropdown-item.active {\n    color: white;\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n}\n\n/* Mobile backdrop overlay */\n.navbar-vertical-backdrop {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1020;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.navbar-vertical .container-fluid {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.navbar-vertical .navbar-brand {\n  padding: 1rem;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 64px;\n  position: sticky;\n  top: 0;\n  background-color: inherit;\n  z-index: 1;\n}\n\n.navbar-vertical .navbar-collapse {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 1rem;\n  /* Hide scrollbar for IE, Edge and Firefox */\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.navbar-vertical .navbar-collapse::-webkit-scrollbar {\n  display: none;\n}\n\n.navbar-vertical:hover {\n  overflow: visible;\n}\n\n.navbar-vertical .logo-expanded {\n  max-width: 120px;\n  height: auto;\n  filter: brightness(0) invert(1);\n  will-change: opacity;\n}\n\n.navbar-vertical .logo-collapsed {\n  filter: brightness(0) invert(1);\n  width: 66px;\n  height: 66px;\n  will-change: opacity;\n}\n\n.navbar-vertical.bg-dark {\n  background-color: #1f656c !important;\n}\n\n.navbar-vertical .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n  padding: 0.5rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n}\n\n.navbar-vertical .nav-link:hover {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-vertical .nav-link.active {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-vertical.collapsed {\n  width: 4.5rem;\n}\n\n.navbar-vertical.collapsed .navbar-brand {\n  padding: 0.5rem;\n}\n\n.navbar-vertical.collapsed .nav-link-title,\n.navbar-vertical.collapsed .navbar-divider {\n  opacity: 0;\n  display: none;\n}\n\n/* Keep small text visible but hidden when collapsed */\n.navbar-vertical.collapsed .small.text-muted {\n  visibility: hidden;\n  opacity: 1;\n}\n\n.navbar-vertical.collapsed .nav-link {\n  padding: 0.5rem;\n  justify-content: center;\n}\n\n.navbar-vertical.collapsed .nav-link-icon {\n  margin: 0;\n}\n\n/* Show text when hovering over collapsed sidebar */\n.navbar-vertical.collapsed:hover .small.text-muted {\n  visibility: visible;\n}\n\n/* Dropdown styles */\n.navbar-vertical .dropdown-menu {\n  margin-left: 1rem;\n  background-color: rgba(31, 101, 108, 0.95);\n  backdrop-filter: blur(10px);\n  border: none;\n  border-radius: 0.5rem;\n}\n\n.navbar-vertical.collapsed .dropdown-menu {\n  margin-left: 4.5rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.mobile-menu.dropdown-item {\n  color: rgba(255, 255, 255, 0.7);\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n}\n\n.mobile-menu.dropdown-item:hover {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.dropdown-item.active {\n  color: #ffffff;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n/* Ensure sidebar dropdown items render icons consistently on all screen sizes */\n.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  gap: 0.35rem;\n  white-space: normal;\n  line-height: 1.25;\n}\n\n.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item svg {\n  flex: 0 0 auto;\n}\n\n.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item .flex-grow-1,\n.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item span:not(.badge) {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.navbar-vertical .navbar-nav .dropdown-menu .dropdown-item .badge {\n  flex: 0 0 auto;\n}\n\n/* Main content wrapper styles */\n.page-wrapper {\n  flex: 1;\n  min-width: 0;\n  margin-left: 15rem;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  will-change: margin-left;\n}\n\n.navbar-vertical.collapsed + .page-wrapper {\n  margin-left: 4.5rem;\n}\n\n/* Header styles */\n.navbar {\n  padding: 0.5rem 1rem;\n  background-color: #fff;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n/* Main content styles */\n.page-content {\n  flex: 1;\n  min-height: 0;\n  padding: 1.5rem;\n  background-color: #f8fafc;\n}\n\n/* ═══════════════════════════════════════════════════════════\n * GLOBAL MOBILE RESPONSIVE — applies to ALL pages\n * ═══════════════════════════════════════════════════════════ */\n\n/* ── Smooth page transitions ──────────────────────────────── */\n/* .modal is deliberately absent: `transition: all` on it overrides Bootstrap's\n   own `.modal.fade` opacity ramp and `.modal.fade .modal-dialog` transform\n   ramp with a single blanket curve, so open/close animates inconsistently.\n   Bootstrap already ships the transitions the modal needs. */\n.page-content,\n.card,\n.btn,\n.nav-link,\n.dropdown-menu,\n.offcanvas {\n  transition: all 0.2s ease;\n}\n\n.card {\n  transition: box-shadow 0.2s ease, transform 0.15s ease;\n}\n\n.btn {\n  transition: background-color 0.15s ease, border-color 0.15s ease,\n              box-shadow 0.15s ease, transform 0.1s ease;\n}\n\n.btn:active {\n  transform: scale(0.97);\n}\n\n/* ── Table responsive: horizontal scroll on mobile ───────── */\n@media (max-width: 992px) {\n  /* All tables inside cards scroll horizontally */\n  .card-body > .table,\n  .card-body > .table-responsive > .table,\n  .card > .table {\n    min-width: 540px;\n  }\n\n  /* Wrap bare tables (not already in table-responsive) */\n  .card-body {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Prevent the whole page from horizontal scroll */\n  .page-wrapper {\n    overflow-x: hidden;\n  }\n\n  /* Setting overflow-x alone forces the browser to compute overflow-y as\n     auto too (CSS overflow spec), turning .page-wrapper into a clipping\n     context for any position:absolute descendant — including the desktop\n     navbar's UserMenu/NotificationDropdown dropdown-menu, which then\n     rendered visibly cut off instead of overlaying the page. Escape it with\n     position:fixed, the same pattern already used for\n     .mobile-navbar-actions .dropdown-menu below. */\n  .container-fluid > header.navbar .dropdown-menu {\n    position: fixed;\n    top: 4.5rem;\n    right: 1rem;\n  }\n\n  /* Page header: stack action buttons on small screens */\n  .page-header .row {\n    row-gap: 0.5rem;\n  }\n\n  .page-header .col-auto {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* Card padding tighter on mobile */\n  .card-body {\n    padding: 0.875rem;\n  }\n\n  /* Badge / status chips don't break */\n  .badge {\n    white-space: nowrap;\n  }\n\n  /* Table font slightly smaller on mobile */\n  .table {\n    font-size: 0.85rem;\n  }\n\n  /* Table header: prevent wrapping in th */\n  .table th {\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 576px) {\n  .page-content {\n    padding: 0.75rem;\n  }\n\n  .card-body {\n    padding: 0.625rem;\n  }\n\n  .table {\n    font-size: 0.8rem;\n  }\n\n  /* Stat / KPI cards: 2 per row on very small screens */\n  .col-sm-6.col-lg-3,\n  .col-6.col-lg-3 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  /* Buttons full-width when stacked */\n  .btn-block-mobile {\n    width: 100%;\n  }\n\n  /* Modals: full screen feel */\n  .modal-dialog {\n    margin: 0.5rem;\n    max-width: calc(100vw - 1rem);\n  }\n}\n\n/* ── Prevent content overflow globally ───────────────────── */\nimg,\nvideo,\niframe {\n  max-width: 100%;\n  height: auto;\n}\n\n/* ── Offcanvas: full width on very small screens ─────────── */\n@media (max-width: 480px) {\n  .offcanvas {\n    width: 100vw !important;\n    max-width: 100vw !important;\n  }\n}\n\n/* Additional touch optimizations */\n@media (hover: none) {\n  .navbar-vertical .nav-link:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n  }\n\n  .cursor-pointer:hover {\n    background-color: transparent;\n  }\n\n  .navbar-vertical .dropdown-item:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n  }\n}\n\n.nav-item-tab .nav-link{\n  color: #6b7280;\n}\n\n.nav-item-tab .nav-link:hover{\n  color: #000000;\n}\n\n.nav-item-tab .nav-link.active{\n  color: #000000;\n}\n\n/* Table sorting styles */\n.cursor-pointer {\n  cursor: pointer;\n  user-select: none;\n}\n\n.cursor-pointer:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.sort-icon {\n  display: inline-block;\n  vertical-align: middle;\n  opacity: 0.3;\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.sort-icon.text-primary {\n  opacity: 1;\n}\n\nth[data-sort]:hover .sort-icon {\n  opacity: 0.8;\n}\n\n/* Mobile menu dropdown styles - keeping these separate */\n@media (max-width: 992px) {\n  .mobile-menu .dropdown-menu {\n    position: static !important;\n    background-color: rgba(0, 0, 0, 0.2);\n    border: none;\n    margin: 0;\n    padding: 0.5rem 0;\n    transform: none !important;\n    transition: max-height 0.3s ease-in-out;\n    max-height: 0;\n    overflow: hidden;\n  }\n\n  .mobile-menu .dropdown.show .dropdown-menu {\n    max-height: 500px;\n  }\n\n  .mobile-menu .dropdown-item {\n    color: rgba(255, 255, 255, 0.7);\n    padding: 0.75rem 3rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.2s ease;\n  }\n\n  .mobile-menu .dropdown-item:active,\n  .mobile-menu .nav-link:active {\n    background-color: rgba(255, 255, 255, 0.15);\n    color: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
